import { toast } from "sonner";

interface CopyToastMessages {
  /** Omit when the surface reports success itself, such as an inline "Copied" state. */
  success?: string;
  failure: string;
}

/**
 * Write `text` to the system clipboard and report the outcome.
 *
 * Every copy affordance goes through this one body. `navigator.clipboard.writeText` rejects on a
 * denied permission and on a document that does not have focus, so a copy that reports success
 * without awaiting the write tells the reader their text is on the clipboard when it is not.
 *
 * Returns whether the write landed, for callers whose success feedback is not a toast.
 */
export async function copyTextToClipboard(
  text: string,
  messages: CopyToastMessages
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    if (messages.success) toast.success(messages.success);
    return true;
  } catch {
    toast.error(messages.failure);
    return false;
  }
}
